import React, { useState } from "react";
import { useConsentStore } from "../store/useConsentStore";
import CookieSettingsModal from "./CookieSettingModal";

export default function Cookie() {
  const consent = useConsentStore((state) => state.consent);
  const [showModal, setShowModal] = useState(false);
  const { acceptAll, rejectAll } = useConsentStore();
  if (consent) return null;
  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 bg-sidom-dark text-sidom-light p-4 z-40">
        <div className="flex flex-col sm:flex-row justify-between items-center max-w-5xl mx-auto">
          <p className="text-sm mb-2 sm:mb-0">
            Este sitio web utiliza cookies propias y de terceros para el
            correcto funcionamiento y visualización del sitio web por parte del
            usuario, así como la recogida de estadísticas tal y como se recoge
            en la política de cookies en la columna "finalidad". Puede cambiar
            la configuración u obtener más información.
          </p>
          <div className="flex gap-2 w-[50%] ">
            <button
              onClick={rejectAll}
              className="bg-gray-700 px-3 py-1 rounded"
            >
              Rechazar todas
            </button>
            <button
              onClick={acceptAll}
              className="bg-sidom-orange px-3 py-1 rounded"
            >
              Aceptar todas
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="bg-sidom-light text-sidom-dark px-3 py-1 rounded"
            >
              Configurar
            </button>
          </div>
        </div>
      </div>
      {showModal && <CookieSettingsModal onClose={() => setShowModal(false)} />}
    </>
  );
}
